import { ParticipantQueryOptions } from "@pulse/api/queryApi";
import { queryClient } from "@pulse/queryClient";
import { notFound } from "@tanstack/react-router";
import { isAxiosError } from "axios";

export function loadSurveyParticipant(participantId: string) {
    return queryClient
        .ensureQueryData(ParticipantQueryOptions({ participantId }))
        .then((participant) => {
            if (!participant) {
                throw notFound();
            }

            return participant;
        })
        .catch((err) => {
            if (!isAxiosError(err)) throw err;

            switch (err.status) {
                case 404:
                    throw notFound();
                case 400:
                    throw notFound();
                default:
                    throw err;
            }
        });
}
